import {Manufacturer} from "../manufacturer/Manufacturer";
import {DataUnit} from "../data-unit/DataUnit";
import {ProtocolTypeEnum} from "../../enums/registry/ProtocolTypeEnum";

export class DeviceType {
  id!: number;
  modelName!: string;
  partNumber?: string;
  modbusWritePauseMillis?: number;
  manufacturer?: Manufacturer;
  protocolType!: ProtocolTypeEnum;

  metricGroups?: MetricGroup[] = [];

  constructor() {
    this.metricGroups = [];
  }

}

export class MetricGroup {
  id?: number;
  name?: string;
  transportConfiguration?: any;
  metrics?: Metric[] = [];
  isWritableOnEdge?: boolean;

  constructor() {
    this.metrics = [];
  }
}

export class Metric {
  id?: number;
  name!: string;
  dataUnit?: DataUnit;
  divider?: number | null;
  decimalDigits?: number;
  isWritableOnEdge?: boolean;
  selected?: boolean;
  transportConfiguration: any;
  metricInstance?: MetricInstance;
}

export class MetricInstance {
  id!: number;
  wm2eInfo?: WM2EInfo;

  // FE ONLY
  showInvalidBadge?: boolean;
}

export class WM2EInfo {
  originType?: string;
  origin?: WM2EOrigin;
}

export class WM2EOrigin {
  id!: number;
  partitionId!: number;
  partitionName!: string;
  name!: string;
  deviceId!: number | null;
  deviceName!: string | null;
}
